import { Component, Input } from '@angular/core';
import '@diekeure/dcr-components/dcr-animated-kai.js';

@Component({
  standalone: false,
  selector: 'campus-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  @Input() src: string;
  @Input() showLabel = true;
  @Input() label = 'bezig met laden...';
}
